<template>
  <div :class="{ 'pointer-events-none': disabled }">
    <input ref="input"
           class="w-full rounded-lg transition"
           :class="[`size-${size} bg-${bgColor} textalign-${textalign}`]"
           :type="type"
           :value="value"
           :disabled="disabled"
           :minlength="minlength"
           :maxlength="maxlength"
           :placeholder="placeholder"
           @input="onInput"
           @keydown.esc="onEvent"
           @keydown.enter="onEvent"
           @focusout="onFocusout"
    />
    <p v-if="helpText"
       class="text-sm text-gray-400 select-none"
       :class="helpTextColor"
    >{{ helpText }}</p>
    <ul v-if="checkList.length > 0" class="mt-1 p-1.5 flex flex-col gap-y-2">
      <li v-for="(checkItem, checkItemIndex) in checkList" :key="checkItemIndex">
        <GrmCheckbox
          disabled
          :id="checkItemIndex"
          v-model="checkItem.checked"
        >{{ checkItem.text }}</GrmCheckbox>
      </li>
    </ul>
  </div>
</template>

<script>
import GrmCheckbox from "@/components/Common/input/GrmCheckbox";

export default {
  name: 'GrmTextField',
  components: {
    GrmCheckbox
  },
  props: {
    min: { type: Number },
    max: { type: Number },
    type: { type: String, default: 'text' },
    size: { type: String, default: 'sm' },
    value: { type: [String, Number] },
    focus: { type: Boolean, default: false },
    bgColor: { type: String, default: 'gray' },
    disabled: { type: Boolean, default: false },
    helpText: { type: String, default: '' },
    minlength: { type: Number, default: 0 },
    maxlength: { type: Number },
    checkList: { type: Array, default: () => [] },
    textalign: { type: String, default: 'left' },
    placeholder: { type: String, default: '' },
  },
  computed: {
    helpTextColor() {
      return this.value.length > this.minlength && this.value.length <= this.maxlength ? 'text-blue-400' : 'text-red-400';
    }
  },
  mounted() {
    if (this.focus) {
      this.$refs.input.focus();
    }
  },
  methods: {
    onEvent(e) {
      this.$emit(e.type, e);
    },
    onInput(e) {
      let { value } = e.target;
      const isValue = !!value;

      switch (this.type) {
        case 'number':
          if (isValue) {
            value = Number(value);
            if (value > this.max) {
              value = this.max
              e.target.value = value;
            } else if (value < this.min) {
              value = this.min
              e.target.value = value;
            }
          }
          break;
        case 'text':
          if (isValue) {
            if (value.length > this.maxlength) {
              value = value.slice(0, this.maxlength);
              e.target.value = value;
            }
          }
          break;
        default:
          break;
      }

      this.$emit('input', value);
    },
    onFocusout(e) {
      let { value } = e.target;

      if (this.type === 'number') {
        if (!value || Number(value) < this.min) {
          value = this.min
          e.target.value = value;
          this.$emit('input', value);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
input {
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
.size- {
  &2xs { @apply h-5 py-1 px-2 text-2xs }
  &xs { @apply h-7 py-2 px-3 text-xs }
  &sm { @apply h-9 py-3 px-4 text-sm }
  &md { @apply h-11 py-4 px-5 text-base }
}
.bg- {
  &gray { @apply bg-gray-100 }
  &red { @apply bg-red-100 }
  &yellow { @apply bg-yellow-100 }
  &green { @apply bg-green-600 }
  &blue { @apply bg-blue-100 }
  &indigo { @apply bg-indigo-100 }
  &purple { @apply bg-purple-100 }
  &pink { @apply bg-pink-100 }
}
.textalign- {
  &left { @apply text-left }
  &center { @apply text-center }
  &right { @apply text-right }
}
</style>